
export default {
    storeUuid( state , val ){
        state.companyUuid = val;
    },
    storeBoxSelect(state,val){
        state.selection = val;
    }
}


// WEBPACK FOOTER //
// ./src/vuex/modules/company/mutations.js